import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="w-full bg-[#050505] border-t border-white/5 pt-16 pb-8 px-8 md:px-16 lg:px-24 font-sans relative z-10">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between gap-12 lg:gap-24">
                
                {}
                <div className="flex flex-col gap-6 lg:w-1/3">
                    <div className="flex flex-col gap-1 text-gray-500 text-xs">
                        <span>A division of</span>
                        <div className="text-white text-xl font-bold tracking-widest uppercase">LINKEY</div>
                    </div>
                    <div className="text-gray-600 text-xs mt-2">
                        &copy; 2026 Linkey Corp.
                    </div>
                    
                    <div className="mt-auto pt-16">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer bg-white/5 backdrop-blur-sm w-fit">
                            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                            </svg>
                            Built with Linkey
                        </div>
                    </div>
                </div>

                {}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-16 lg:w-2/3">
                    {}
                    <div className="flex flex-col gap-4">
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide">Products</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Create Link</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Analytics</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Integrations</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Dashboard</Link>
                        
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide mt-4">Download</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Linkey App</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">iOS</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Android</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Telegram Bot</Link>
                    </div>

                    {}
                    <div className="flex flex-col gap-4">
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide">Solutions</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Creators</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Agencies</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Brands</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Developers</Link>
                    </div>

                    {}
                    <div className="flex flex-col gap-4">
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide">Developers</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Pricing</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Documentation</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Status</Link>
                        
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide mt-4">Enterprise</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Contact Sales</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">FAQs</Link>

                    </div>

                    {}
                    <div className="flex flex-col gap-4">
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide">Company</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">About</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Careers</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">News</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Contact</Link>
                        
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide mt-4">Legal</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Terms</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Privacy</Link>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">Cookies</Link>
                        
                        <h4 className="text-gray-300 text-[13px] font-semibold tracking-wide mt-4">Social</h4>
                        <Link to="#" className="text-gray-500 text-xs hover:text-white transition-colors">@linkey</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
